import React, { useState, useEffect } from 'react';
import { Table, Typography, Tag, DatePicker, Space, Button } from 'antd';
import { ReloadOutlined } from '@ant-design/icons';
import axios from '../../utils/request';
import dayjs from 'dayjs';

const { Title } = Typography;
const { RangePicker } = DatePicker;

interface RedemptionRecord {
  _id: string;
  code: string;
  name: string;
  usedAt: string;
  ekokNumber: string;
  customerName: string;
}

const SalesRecords: React.FC = () => {
  const [records, setRecords] = useState<RedemptionRecord[]>([]);
  const [loading, setLoading] = useState(false);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0
  });
  const [dateRange, setDateRange] = useState<any>(null);

  const fetchRecords = async (page = 1, pageSize = 10) => {
    setLoading(true);
    try {
      const response = await axios.get(`/api/coupons/records?page=${page}&limit=${pageSize}`);
      setRecords(response.data.records);
      setPagination({
        current: page,
        pageSize,
        total: response.data.pagination.total
      });
    } catch (error: any) {
      console.error('获取核销记录失败:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchRecords();
  }, []);

  const handleRefresh = () => {
    fetchRecords(pagination.current, pagination.pageSize);
  };

  const columns = [
    {
      title: '优惠码',
      dataIndex: 'code',
      key: 'code',
      width: 120,
    },
    {
      title: '优惠券名称',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: 'EKOK号码',
      dataIndex: 'ekokNumber',
      key: 'ekokNumber',
      width: 120,
    },
    {
      title: '客人姓名',
      dataIndex: 'customerName',
      key: 'customerName',
      width: 100,
    },
    {
      title: '核销时间',
      dataIndex: 'usedAt',
      key: 'usedAt',
      width: 150,
      render: (date: string) => (
        <div>
          <div>{dayjs(date).format('MM-DD')}</div>
          <div style={{ fontSize: '12px', color: '#999' }}>
            {dayjs(date).format('HH:mm')}
          </div>
        </div>
      ),
    },
    {
      title: '状态',
      key: 'status',
      width: 80,
      render: () => <Tag color="green">已核销</Tag>,
    },
  ];

  const todayRecords = records.filter(record => 
    dayjs(record.usedAt).isSame(dayjs(), 'day')
  );


  return (
    <div style={{ padding: '24px' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
        <Title level={3}>我的核销记录</Title>
        <Button icon={<ReloadOutlined />} onClick={handleRefresh}>
          刷新
        </Button>
      </div>
      
      <div style={{ 
        marginBottom: '16px', 
        background: '#f6ffed', 
        padding: '16px', 
        borderRadius: '6px',
        border: '1px solid #b7eb8f'
      }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <div>
            <span style={{ fontSize: '16px', fontWeight: 'bold', color: '#52c41a' }}>
              今日核销统计
            </span>
          </div>
          <Space size="large">
            <div style={{ textAlign: 'center' }}>
              <div style={{ fontSize: '24px', fontWeight: 'bold', color: '#52c41a' }}>
                {todayRecords.length}
              </div>
              <div style={{ fontSize: '12px', color: '#666' }}>核销数量</div>
            </div>
          </Space>
        </div>
      </div>

      <div style={{ marginBottom: '16px', background: '#fafafa', padding: '16px', borderRadius: '6px' }}>
        <Space wrap>
          <RangePicker
            placeholder={['开始日期', '结束日期']}
            value={dateRange}
            onChange={(dates) => setDateRange(dates)}
          />
          <Button type="primary">
            筛选
          </Button>
          <Button onClick={() => setDateRange(null)}>
            清除
          </Button>
        </Space>
      </div>

      <Table
        columns={columns}
        dataSource={records}
        rowKey="_id"
        loading={loading}
        pagination={{
          ...pagination,
          showSizeChanger: true,
          showQuickJumper: true,
          showTotal: (total, range) =>
            `第 ${range[0]}-${range[1]} 条，共 ${total} 条记录`,
          onChange: (page, pageSize) => {
            fetchRecords(page, pageSize);
          }
        }}
        scroll={{ x: 600 }}
      />
    </div>
  );
};

export default SalesRecords;